export default {
  pc: [
    { title: '이용권', link: '/pass/pass' },
    { title: 'S포인트', link: '/pass/point' },
    { title: '머니', link: '/pass/sbsmoney' },
    { title: '쿠폰', link: '/pass/coupon' },
    { title: '쿠폰등록', link: '/pass/couponEnter' }
  ],
  mobile: [
    { title: '이용권', link: '/m/pass/pass' },
    { title: 'S포인트', link: '/m/pass/point' },
    { title: '머니', link: '/m/pass/sbsmoney' },
    { title: '쿠폰', link: '/m/pass/coupon' },
    { title: '쿠폰등록', link: '/m/pass/couponEnter' }
  ],
  app: [
    { title: '이용권', link: '/m/pass/pass' },
    { title: 'S포인트', link: '/m/pass/point' },
    { title: '쿠폰', link: '/m/pass/coupon' },
    { title: '쿠폰등록', link: '/m/pass/couponEnter' }
  ],
  app_en: [
    { title: 'SUBSCRIPTION', link: '/m/pass/pass' },
    { title: 'S POINT', link: '/m/pass/point' },
    { title: 'COUPON', link: '/m/pass/couponEnter' }
  ]
};